import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useFadeObserver } from '../../hooks/fadeObserver.hook';

export const PricingElement = ({ title, description, index }) => {
  const ref = useRef(null);

  useFadeObserver(ref);

  return (
    <div className="pricing-benefit-column col-12 col-lg-4 d-flex mb-4">
      <div
        className={`pricing-value-card bg-blue-light rounded flex-grow-1 text-center p-4 d-flex flex-column justify-content-center fade-on-screen fade-delay-${index}`}
        ref={ref}
      >
        <div className="font-weight-bold pricing-value-prop mb-1">{title}</div>
        {description.split('|').map(line => (
          <div className="pricing-value-copy" key={line}>
            {line}
          </div>
        ))}
      </div>
    </div>
  );
};

PricingElement.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};
